import { ActionReducerMap } from '@ngrx/store';
import { InvViewColumnViewModelStates } from '../states';
import * as fromColumn1ViewModelReducers from '../reducers/column_1_view_model.reducers';
export const columnViewModelFeatureKey4 = 'genericDocInvViewModel';
export const columnViewModelReducers4: ActionReducerMap<InvViewColumnViewModelStates> = {
  column1ViewModel: fromColumn1ViewModelReducers.reducer,
};